import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, catchError, filter, finalize, map, switchMap, take, tap, from as observableFrom } from 'rxjs';
import { DocumentModel } from 'src/app/models/document.model';
import { PdfDocumentService } from 'src/app/services/pdf-document.service';
import { PortalService } from 'src/app/services/portal.service';
import { SendDocumentDialogComponent } from '../dialogs/send-document-dialog/send-document-dialog.component';
import { DialogService } from 'src/app/services/dialog.service';
import { LoadingAction } from 'src/app/models/loading-action.model';
import { PortalSendModel } from 'src/app/models/portal-send.model';
import { LoadingService } from 'src/app/services/loading.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'tx-pdf-section-portal',
  templateUrl: './pdf-section-portal.component.html',
  styleUrls: ['./pdf-section-portal.component.scss'],
})
export class PDFSectionPortalComponent implements OnInit, OnDestroy {
  private document!: DocumentModel | null;
  private subscriptions = new Subscription();
  public portalAvailable = false;
  public uploadedPortalFiles: string[] = [];
  //private parent: TxdocsPDFRibbonBarComponent,
  constructor(
    private documentService: PdfDocumentService,
    private dialogService: DialogService,
    private portalService: PortalService,
    private loadingService: LoadingService,
    private changeDetectorRef: ChangeDetectorRef,
    public parent: PdfViewerComponent
  ) {}
  ngOnInit(): void {
    this.subscriptions.add(
      this.documentService.document$.subscribe((document) => {
        this.document = document;
        if (this.document) {
          //must have document selected
          this.portalService.getServices(this.document).subscribe((res: any) => {
            if (res.available === true) {
              this.portalAvailable = true;
              this.uploadedPortalFiles = res.existingFiles;
            } else {
              this.portalAvailable = false;
              this.uploadedPortalFiles = [];
            }
          });
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onSendToPortalClicked() {
    console.log(`----> Hello from onSendToPortalClicked`);
    console.log(`----> is this document: ${JSON.stringify(this.document)}`);
    if (this.document == null) {
      return;
    }
    const document = this.document;
    this.parent
      .checkUnsavedChanges()
      .pipe(
        // only if they said yes to save
        take(1),
        filter((res) => res === true),
        // show send document dialog and wait
        switchMap(() => {
          const modalRef = this.dialogService.openCustomDialog('sendDocument', SendDocumentDialogComponent, {
            size: 'md',
            backdrop: 'static',
          });
          const lastDot = document.filename!.lastIndexOf('.');
          const isPdf = document.filename!.substring(lastDot + 1).toLowerCase() === "pdf";
          const modalInstance = modalRef.componentInstance;
          modalInstance.fileName = document.filename ?? '';
          modalInstance.caseName = document.casDescription ?? '';
          modalInstance.clientName = document.ctcFirstName + ' ' + document.ctcLastName;
          modalInstance.existingFiles = this.uploadedPortalFiles;
          modalInstance.isPdf = isPdf;
          return observableFrom(modalRef.result).pipe(map((res) => modalInstance));
        }),
        tap(() => {
          this.loadingService.loadingAction = LoadingAction.Sending;
          this.loadingService.loading = true;
        }),
        // send document to portal
        switchMap((modalInstance: SendDocumentDialogComponent) => {
          let sendModel = {
            ...this.document,
            description: modalInstance.description,
            filename: modalInstance.fileName,
            targetType: modalInstance.extension.extension,
          } as PortalSendModel;
          return this.portalService.sendDocument(sendModel).pipe(
            catchError((err: any) => {
              console.log(err);
              // this.loading = false;
              if (err.httpStatusCode == 409) {
                this.dialogService.info({
                  title: `Existing Filename`,
                  message: `The file name "${err.fileName}" has already been uploaded.  Please try again.`,
                });
              } else {
                this.dialogService.info({
                  title: `Trouble sending file`,
                  message: `There was a problem sending the file named "${err.fileName}".  Please try again.`,
                });
              }
              throw err;
            })
          );
        }),
        switchMap((res: any) => {
          // ugly but the callbacks below are the end of the chain
          return this.dialogService.info({
            title: `Document Sent Successfully`,
            message: `The document has been sent to the client.`,
          });
        }),
        tap((res) => {
          this.resetLoadingDocumentIndicator();
          return true;
        }),
        finalize(() => {
          this.resetLoadingDocumentIndicator();
        })
      )
      .subscribe((res) => {});
  }
  private resetLoadingDocumentIndicator() {
    this.loadingService.loading = false;
    this.loadingService.loadingAction = LoadingAction.None;
    this.changeDetectorRef.detectChanges();
  }
}
